<script>
import VSelect from '@/components/Common/VSelect';

export default {
  name: 'form-selection',
  props: {
    brandList: {
      type: String,
      default: null,
    }
  },
  components: {
    VSelect
  },
  data() {
    return {
      brand: null,
      model: null,
      modelList: null,
    }
  },
  computed: {
    currentBrandList() {
      return JSON.parse(this.brandList);
    },
    currentBrand() {
      return this.currentBrandList.find(x => x.current_brand === 1) ?? null;
    },
    currentModel() {
      return this.currentBrandList.find(x => x.current_brand === 1)?.models.find(x => x.current_model === 1) ?? null;
    }
  },
  mounted() {
    if(this.currentBrand) {
      this.brand = this.currentBrand;
      this.modelList = this.currentBrand?.models;
      this.model = this.currentModel;
    }
  }
}
</script>
<template>
  <v-select
    v-model="brand"
    :options="currentBrandList"
    placeholder="Выберите марку"
    type-option="anchor"
    :multiple="false"
  ></v-select>
  <v-select
    v-model="model"
    :disabled="!brand"
    :options="modelList"
    placeholder="Выберите модель"
    type-option="anchor"
    :multiple="false"
  ></v-select>
</template>